<div class="milestone" *ngFor="let milestone of milestones" [class.active]="milestone.isActive">
	<div class="milestone-description">{{ milestone.description }}</div>
	<div class="milestone-amount">{{ formatAmount(milestone) }}</div>
	<div class="milestone-goal">{{ formatGoal(milestone) }}</div>
</div>
